import React from 'react';
import { Mail, MapPin, Facebook, Twitter, Linkedin, Instagram, MessageCircle } from 'lucide-react';
import { Button } from './ui/button';

const Footer = () => {
  const whatsappNumber = '918435117379';
  const displayPhone = '+91 84351 17379';
  const supportEmail = 'support@bloomcycleinnovations.in';
  const devEmail = 'dev.bloomcycle@gmail.com';

  return (
    <footer id="contact" className="bg-white border-t border-neo-emerald/20 text-neo-gray">
      <div className="max-w-6xl mx-auto px-4 py-12">
        <div className="grid md:grid-cols-4 gap-8 mb-8">
          <div>
            <div className="bg-white p-2 rounded inline-block mb-4">
              <img 
                src="/BLOOMCYCLE_INNOVATIONS-removebg-preview.webp" 
                  alt="BLOOMCYCLE INNOVATIONS"
                className="h-12 w-auto object-contain"
              />
            </div>
            <p className="text-sm text-neo-gray mb-4 font-body">
              Transforming agriculture into climate solutions through innovative biochar technology.
            </p>
            <div className="flex gap-3">
              <a href="#" className="w-8 h-8 bg-gray-100 border border-neo-emerald/20 rounded-lg flex items-center justify-center hover:bg-neo-emerald hover:border-neo-emerald transition-colors">
                <Facebook className="w-4 h-4" />
              </a>
              <a href="#" className="w-8 h-8 bg-gray-100 border border-neo-emerald/20 rounded-lg flex items-center justify-center hover:bg-neo-emerald hover:border-neo-emerald transition-colors">
                <Twitter className="w-4 h-4" />
              </a>
              <a 
                href="https://www.linkedin.com/company/107438420/admin/dashboard/" 
                target="_blank"
                rel="noopener noreferrer"
                className="w-8 h-8 bg-gray-100 border border-neo-emerald/20 rounded-lg flex items-center justify-center hover:bg-neo-emerald hover:border-neo-emerald transition-colors"
              >
                <Linkedin className="w-4 h-4" />
              </a>
              <a href="#" className="w-8 h-8 bg-gray-100 border border-neo-emerald/20 rounded-lg flex items-center justify-center hover:bg-neo-emerald hover:border-neo-emerald transition-colors">
                <Instagram className="w-4 h-4" />
              </a>
            </div>
          </div>
          
          <div>
            <h4 className="text-neo-black font-heading font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2 text-sm font-body">
              <li><a href="#" className="hover:text-neo-emerald transition-colors">About Us</a></li>
              <li><a href="#" className="hover:text-neo-emerald transition-colors">Our Process</a></li>
              <li><a href="#" className="hover:text-neo-emerald transition-colors">Features</a></li>
              <li><a href="#" className="hover:text-neo-emerald transition-colors">MRV Technology</a></li>
              <li><a href="#" className="hover:text-neo-emerald transition-colors">Impact Stories</a></li>
            </ul>
          </div>
          
          <div>
            <h4 className="text-neo-black font-heading font-semibold mb-4">Support</h4>
            <ul className="space-y-2 text-sm font-body">
              <li><a href="#" className="hover:text-neo-emerald transition-colors">Help Center</a></li>
              <li><a href="#" className="hover:text-neo-emerald transition-colors">FAQs</a></li>
              <li><a href="#" className="hover:text-neo-emerald transition-colors">Terms of Service</a></li>
              <li><a href="#" className="hover:text-neo-emerald transition-colors">Privacy Policy</a></li>
              <li><a href="#" className="hover:text-neo-emerald transition-colors">Contact Us</a></li>
            </ul>
          </div>
          
          <div>
            <h4 className="text-neo-black font-heading font-semibold mb-4">Contact Us</h4>
            <div className="space-y-3 text-sm font-body">
              <a 
                href={`mailto:${supportEmail}`}
                className="flex items-start gap-2 hover:text-neo-emerald transition-colors group"
              >
                <Mail className="w-4 h-4 mt-0.5 flex-shrink-0 group-hover:text-neo-emerald" />
                <span>{supportEmail}</span>
              </a>
              <a 
                href={`mailto:${devEmail}`}
                className="flex items-start gap-2 hover:text-neo-emerald transition-colors group"
              >
                <Mail className="w-4 h-4 mt-0.5 flex-shrink-0 group-hover:text-neo-emerald" />
                <span>{devEmail}</span>
              </a>
              <div className="flex items-start gap-2">
                <MapPin className="w-4 h-4 mt-0.5 flex-shrink-0" />
                <span>H.No 115-C, The Mark Residences, NRI Layout Main Rd 1st Block, Ramamurthy Nagar, Bangalore, Karnataka, India - 560016</span>
              </div>
            </div>
            <a
              href={`https://wa.me/${whatsappNumber}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              <Button className="mt-4 w-full bg-neo-emerald hover:bg-[#1db868] text-neo-white flex items-center gap-2 glow-emerald-hover">
                <MessageCircle className="w-4 h-4" />
                Chat on WhatsApp
              </Button>
            </a>
          </div>
        </div>
        
        <div className="border-t border-neo-emerald/20 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-neo-gray font-body">
            <p>© 2025 BLOOMCYCLE INNOVATIONS. All rights reserved.</p>
            <p>DPIIT Registered Startup • ISO Compliant • Carbon Credits Verified</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
